import { FlowPage } from '@monthio/design-system'
import { useFlowCleanupOnLeave } from '#hooks'
import { useTranslation } from 'react-i18next'

export const FlowDeleted = () => {
	const { t } = useTranslation()
	useFlowCleanupOnLeave()

	const title = t('flowDeletedScreen-text')

	return (
		<FlowPage>
			<FlowPage.Content $isCentered>
				<FlowPage.Header title={title} />
			</FlowPage.Content>
		</FlowPage>
	)
}
